const toNumber = (value, fallback = 0) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : fallback;
};

export const getConfidenceClass = (confidence) => {
  const value = toNumber(confidence, 0);
  if (value >= 80) return 'conf-super';
  if (value >= 70) return 'conf-good';
  return 'conf-mid';
};

export const getEdgeClass = (edge) => {
  const value = toNumber(edge, 0);
  if (value >= 10) return 'edge-super';
  if (value >= 5) return 'edge-good';
  return 'edge-mid';
};
